













import Vue from 'vue'
import { AppNotifications } from '@/components/partials/'

export default Vue.extend({
  components: {
    AppNotifications,
  },
  computed: {
    layout(): string {
      return (this.$route.meta.layout || 'app') + '-layout'
    },
    // cssProps(): { [propName: string]: any } {
    //   return {
    //     '--v-primary-base': this.$vuetify.theme.themes.light.primary,
    //     '--v-primaryGradient-base': this.$vuetify.theme.themes.light
    //       .primaryGradient,
    //     '--v-secondary-base': this.$vuetify.theme.themes.light.secondary,
    //     '--v-secondaryGradient-base': this.$vuetify.theme.themes.light
    //       .secondaryGradient,
    //     '--v-text-base': this.$vuetify.theme.themes.light.text,
    //     '--v-lightText-base': this.$vuetify.theme.themes.light.lightText,
    //     '--v-lightText-lighten3': '#b0bec5',
    //     '--v-lighter-base': this.$vuetify.theme.themes.light.lighter,
    //     '--v-accent-base': this.$vuetify.theme.themes.light.accent,
    //     '--v-fill-base': this.$vuetify.theme.themes.light.fill,
    //     '--v-darkFill-base': this.$vuetify.theme.themes.light.darkFill,
    //     '--v-success-base': this.$vuetify.theme.themes.light.success,
    //     '--v-warning-base': this.$vuetify.theme.themes.light.warning,
    //     '--v-warningGradient-base': this.$vuetify.theme.themes.light
    //       .warningGradient,
    //     '--v-error-base': this.$vuetify.theme.themes.light.error,
    //     '--v-errorGradient-base': this.$vuetify.theme.themes.light
    //       .errorGradient,
    //   }
    // },
  },
})
